module.exports = __webpack_public_path__ + "static/img/role.9cf1cee.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/cz/role.png
// module id = PpTI
// module chunks = 7